import { GameState } from "../../store";

export default function getBonus(state: GameState) {
  return state.game.bonus;
}
